<template>
  <b-progress :max="max">
    <template v-if="low_value > result_value">
      <b-progress-bar
        :value="result_value"
        variant="primary"
        class="text-dark"
      >
        {{ `Low (${result_value})` }}
      </b-progress-bar>
    </template>
    <template v-else-if="result_value > high_value">
      <b-progress-bar variant="primary" :value="low_value" />
      <b-progress-bar variant="success" :value="optimal" />
      <b-progress-bar
        :value="result_value - high_value"
        variant="danger"
        class="text-dark"
      >
        {{ `High (${result_value})` }}
      </b-progress-bar>
    </template>
    <template v-else>
      <b-progress-bar variant="primary" :value="low_value" />
      <b-progress-bar
        :value="result_value - low_value"
        variant="success"
        class="text-dark"
      >
        {{ `Optimal (${result_value})` }}
      </b-progress-bar>
    </template>
  </b-progress>
</template>

<script>
export default {
  name: "ReportProgressBar",
  props: {
    result: {
      type: String,
      default: null
    },
    low: {
      type: String,
      default: null
    },
    high: {
      type: String,
      default: null
    }
  },
  computed: {
    result_value() {
      return Number(this.result);
    },
    low_value() {
      return Number(this.low)
    },
    high_value() {
      return Number(this.high)
    },
    max() {
      return this.high_value + this.low_value;
    },
    optimal() {
      return this.high_value - this.low_value;
    }
  }
}
</script>